function i(n, o) {
  return Object.hasOwn(n.bindings, o);
}
function c(n, o, r) {
  if (!i(n, o))
    throw new Error(
      `${r}: unknown scope "${o}". Known scopes: ${n.scopes.join(", ")}`
    );
}
function t(n, o) {
  for (const r of n.scopes)
    if ((n.bindings[r] ?? []).some((e) => e.id === o))
      return !0;
  return !1;
}
function s(n, o, r) {
  if (!t(n, o))
    throw new Error(`${r}: unknown action id "${o}".`);
}
export {
  s as assertActionId,
  c as assertScope,
  t as hasActionId,
  i as hasScope
};
